import { useEffect, useState } from "react";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
  SelectChangeEvent,
  SelectProps,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllowedDepots } from "../../reduxStore/ScopeSlice";
import { RootState, AppDispatch } from "../../reduxStore/Store";
import { GeneriqueData } from "../../models/models";

interface SelectDepotProps
  extends Omit<SelectProps<number | string>, "value" | "onChange"> {
  onDepotChange: (generiqueData: GeneriqueData | null) => void;
  selectedDepot?: GeneriqueData | null;
  departement_id?: number | null; // filtre les dépôts par département
  label?: string;                 // libellé du champ (défaut "Depot")
}

const SelectDepot: React.FC<SelectDepotProps> = ({
  onDepotChange,
  selectedDepot,
  departement_id,
  label = "Depot",
  ...selectProps
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const { allowedDepots: depotData, loading, error } = useSelector(
    (state: RootState) => state.ScopeSlice
  );
  const [depotId, setDepotId] = useState<number | string>("");

  useEffect(() => {
    dispatch(fetchAllowedDepots({ departement_id }));
  }, [dispatch, departement_id]);

  useEffect(() => {
    // id falsy (0 / null / undefined) → "" pour afficher le placeholder, jamais un "0" parasite
    setDepotId(selectedDepot && selectedDepot.id ? selectedDepot.id : "");
  }, [selectedDepot]);
  const handleChange = (event: SelectChangeEvent<string | number>) => {
    const selectedId = event.target.value;
    const selectedDepot = depotData.find((item) => item.id === Number(selectedId)) || null;
    setDepotId(selectedId);
    onDepotChange(selectedDepot);
  };
  const labelId = `select-depot-label-${label}`;
  return (
    <FormControl fullWidth size="small" variant="outlined" error={!!error}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        value={depotId}
        onChange={handleChange}
        label={label}
        disabled={loading}
        size="small"
        {...selectProps}
      >
        {depotData.length === 0 ? (
          <MenuItem value="">Aucun dépôt trouvé</MenuItem>
        ) : (
          depotData.map((depotItem) => (
            <MenuItem key={depotItem.id} value={depotItem.id}>
              {depotItem.nom}
            </MenuItem>
          ))
        )}
      </Select>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export default SelectDepot;
